import React from "react";
import styled, { css } from "react-emotion";
import PropTypes from "prop-types";

const StyledDeal = styled("div")`
  /* display: inline-table; */
  color: black;
  width: 100%;
  background: #6edb97; /* TODO: update this dynamically later on */
  box-sizing: content-box;
  border-radius: 5px;
  text-align: center;
  margin: ${(props) => (props.margin ? props.margin : "5 0 10 0")};
  /* background: ${(props) =>
    props.background ? props.background : "#89d2d3"}; */
  background: ${(props) => (props.background ? props.background : "white")};
  /* border: ${(props) => props.border}; */
  border: ${(props) => "1px solid " + props.color};
  /* background: ${(props) => props.background}; */
  padding-top: 10px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background: #e7e7e7;
    transform: scale(1.02);
  }
`;

const RedeemButton = styled("p")`
  background: white;
  border-radius: 25px;
  border: ${(props) => "1px solid " + props.color};
  color: ${(props) => props.color};
  font-size: 12px;
  padding: 10px;
  width: 200px;
  margin: 20px auto !important;
`;

const smallText = css`
  font-size: 9px;
  height: auto;
  color: black;
`;

const finePrintStyle = css`
  font-size: 9px;
  word-wrap: break-word;
  color: black;
  text-decoration: underline;
`;

const descriptionStyle = css`
  color: black;
  /* word-wrap: break-word; */
`;

const Deal = ({
  id,
  color,
  title,
  description,
  expiration,
  maxUses,
  finePrint,
  retired,
  onClick,
  margin,
  border,
  barColor,
}) => {
  const parsedExpiration = new Date(expiration).toLocaleDateString("en-US");

  return (
    <StyledDeal
      key={id}
      border={border}
      margin={margin}
      background={retired ? "grey" : null}
      onClick={() => onClick(id)}
      color={barColor}
    >
      <h2 style={{ color: "black" }}>{title}</h2>
      <h4 className={descriptionStyle}>{description}</h4>
      {/* {expiration && <p className={smallText}>{parsedExpiration}</p>} */}
      <RedeemButton color={barColor}>Redeem Offer</RedeemButton>
      <div
        style={{
          display: "flex",
          justifyContent:
            (maxUses && !finePrint) || (expiration && !finePrint)
              ? "start"
              : "space-between",
          padding: "0px 10px",
        }}
      >
        {maxUses && expiration ? (
          <p className={smallText}>
            Expires: {parsedExpiration} | Uses Remaining: {maxUses}
          </p>
        ) : null}
        {!maxUses && expiration ? (
          <p className={smallText}>Expires: {parsedExpiration}</p>
        ) : null}
        {maxUses && !expiration ? (
          <p className={smallText}>Uses Remaining: {maxUses}</p>
        ) : (
          <p className={smallText}></p>
        )}
        {finePrint ? (
          <p className={finePrintStyle}>Fine Print</p>
        ) : (
          <p className={finePrintStyle}></p>
        )}
      </div>
    </StyledDeal>
  );
};

Deal.propTypes = {
  deals: PropTypes.object,
  onClick: PropTypes.func,
};

export default Deal;
